import styles from "./styles.module.css";
import * as Editors from "../../../editors";
import { useState, useEffect } from "react";
export default function PropInput({
  prop,
  block,
  index,
  onChange,
  sources,
  onDelete,
}) {
  const Input = Editors[prop.editor];
  const [params, setParams] = useState(prop.editorParams);
  const [_sources, setSources] = useState(sources);
  const _onChange = (v) => {
    const _block = { ...block };
    _block.props[prop.name] = v;
    onChange(_block);
  };

  useEffect(() => {
    const type = prop.editorParams.type;
    if (block.props[type]) {
      const _params = { ...prop.editorParams };
      _params.type = block.props[prop.editorParams.type];
      setParams(_params);
    } else {
      setParams(prop.editorParams);
    }
  }, [prop.editorParams, block]);

  useEffect(() => {
    try {
      if (prop.editorParams.sources) {
        const propSources = prop.editorParams.sources.map((s) => {
          const _s = { ...s };

          if (block.props[s.returnType]) {
            _s.returnType = block.props[s.returnType];
          }
          return _s;
        });
        setSources([...propSources, ...sources]);
      }
    } catch (err) {
      return setSources(sources);
    }
  }, [sources, prop]);

  if (!Input || !params) {
    return null;
  }
  return (
    <div style={{ zIndex: 300 - index }} className={styles.propInput}>
      <div className={styles.propTitle}>{prop.displayName}</div>
      <Input
        value={block.props[prop.name]}
        params={params}
        onChange={_onChange}
        sources={_sources}
      />
      <div className={styles.propHelp}>{prop.help}</div>
      {onDelete && (
        <div onClick={onDelete} className={styles.deleteProp}>
          Delete
        </div>
      )}
    </div>
  );
}
